import { render, staticRenderFns } from "./DisputeTransactionInfo.vue?vue&type=template&id=7e247cc6&"
import script from "./DisputeTransactionInfo.vue?vue&type=script&lang=js&"
export * from "./DisputeTransactionInfo.vue?vue&type=script&lang=js&"
import style0 from "./DisputeTransactionInfo.vue?vue&type=style&index=0&id=7e247cc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports